



































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import CouponHelpers, { Coupon } from "@/models/coupon";
const log = NSLog("view/ManageCoupons");

@Component({
  components: {
    loader
  }
})
export default class EditCouponDialog extends Vue {
  @Prop({ required: true }) public value: any;

  @Mutation("setLastErr") public setLastErr: any;
  private saving = false;
  private valid = false;
  private item: Coupon = CouponHelpers.New();

  public created() {
    this.item =
      this.value && this.value !== true
        ? Object.assign({}, this.value)
        : CouponHelpers.New();
  }

  public dialogInput(v: any) {
    if (!v) { this.$emit("input", false); }
  }

  public async save() {
    this.saving = true;
    let coupon: Coupon;
    try {
      if (this.item.id) {
        coupon = await billingApi.updateCoupon(this.item.id, this.item);
      } else {
        coupon = await billingApi.createCoupon(this.item);
      }
      // if success, close & clear
      this.$emit("input", coupon);
    } catch (err) {
      this.setLastErr(String(err));
    }
  }
}
